import AjaxClass from './ajaxClass';

export default class ConversionPopup {
    constructor() {
        this.popup = document.getElementById('conversion-popup');
        if (!this.popup) return;

        this.simulationId = null;

        this.bindChoiceButtons();
        this.bindBackButtons();
        this.bindChannelForms();
        this.bindClose();
    }

    open(simulationId, prefillEmail = '', prefillPhone = '') {
        if (!this.popup) return;

        this.simulationId = simulationId;
        this.resetForms();

        // Preenche o e-mail/telefone já digitados no form principal, se houver.
        if (prefillEmail) {
            const emailInput = this.popup.querySelector('form[data-channel-form="email"] input[name="value"]');
            if (emailInput) emailInput.value = prefillEmail;
        }
        if (prefillPhone) {
            const phoneInput = this.popup.querySelector('form[data-channel-form="whatsapp"] input[name="value"]');
            if (phoneInput) phoneInput.value = prefillPhone;
        }

        this.showStep('choice');
        this.popup.classList.add('open-modal');
    }

    close() {
        if (!this.popup) return;
        this.popup.classList.remove('open-modal');
    }

    showStep(step) {
        this.popup.querySelectorAll('[data-popup-step]').forEach(el => {
            el.style.display = el.dataset.popupStep === step ? 'block' : 'none';
        });
    }

    resetForms() {
        this.popup.querySelectorAll('[data-channel-form]').forEach(form => {
            form.reset();
            const input = form.querySelector('input');
            const error = form.querySelector('[data-popup-error]');
            if (input) input.classList.remove('is-invalid');
            if (error) error.style.display = 'none';
            const submitButton = form.querySelector('[type="submit"]');
            if (submitButton) submitButton.disabled = false;
        });
    }

    bindChoiceButtons() {
        this.popup.querySelectorAll('[data-channel]').forEach(btn => {
            btn.addEventListener('click', () => {
                // E-mail e WhatsApp funcionam igual agora: mostra um formulário
                // pedindo o valor (e-mail ou telefone) antes de enviar.
                this.showStep(btn.dataset.channel);
            });
        });
    }

    bindBackButtons() {
        this.popup.querySelectorAll('[data-popup-back]').forEach(btn => {
            btn.addEventListener('click', () => this.showStep('choice'));
        });
    }

    bindClose() {
        this.popup.querySelectorAll('[data-popup-close]').forEach(btn => {
            btn.addEventListener('click', () => this.close());
        });

        // Clique fora do conteúdo fecha o pop-up
        this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup) this.close();
        });
    }

    bindChannelForms() {
        this.popup.querySelectorAll('[data-channel-form]').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.submitChannel(form);
            });

            // Validação em tempo real: some com o erro assim que o valor
            // digitado já for válido, sem esperar o submit.
            const channel = form.dataset.channelForm;
            const input = form.querySelector('input[name="value"]');
            const error = form.querySelector('[data-popup-error]');
            if (input) {
                input.addEventListener('input', () => {
                    if (this.isValid(channel, input.value.trim())) {
                        input.classList.remove('is-invalid');
                        if (error) error.style.display = 'none';
                    }
                });
            }
        });
    }

    isValid(channel, value) {
        if (channel === 'email') {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        }
        if (channel === 'whatsapp') {
            return value.replace(/\D/g, '').length >= 10;
        }
        return true;
    }

    submitChannel(form) {
        const channel = form.dataset.channelForm; // 'email' | 'whatsapp'
        const input = form.querySelector('input[name="value"]');
        const error = form.querySelector('[data-popup-error]');
        const value = input.value.trim();

        if (!value || !this.isValid(channel, value)) {
            input.classList.add('is-invalid');
            if (error) error.style.display = 'block';
            return;
        }

        input.classList.remove('is-invalid');
        if (error) error.style.display = 'none';

        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        // O WhatsApp só pode abrir depois que o PDF for gerado (resposta do
        // servidor), mas o navegador só permite abrir aba dentro do clique.
        // Por isso reservamos a aba agora e apontamos pro wa.me quando a
        // resposta chegar.
        let waWindow = null;
        if (channel === 'whatsapp') {
            waWindow = window.open('', '_blank');
            if (waWindow) {
                waWindow.document.title = 'WhatsApp';
                waWindow.document.body.textContent = 'Gerando sua simulação...';
            }
        }

        const Loader = document.getElementById('loading-forms');
        if (Loader) Loader.classList.add('open-modal');

        const formData = new FormData();
        formData.append('simulation_id', this.simulationId);
        formData.append('channel', channel);
        formData.append('value', value);

        const self = this;

        const failWhatsapp = () => {
            if (waWindow && !waWindow.closed) waWindow.close();
        };

        class FinalStep extends AjaxClass {
            successFunction(data) {
                if (submitButton) submitButton.disabled = false;

                // O número vem do admin (Adm > Simulação > Página > Etapa 3),
                // exposto globalmente em window.wppNumber (ver app.blade.php).
                // `data.redirectNumber` é o mesmo valor, já resolvido pelo
                // servidor no momento do envio — preferimos ele por ser mais
                // recente que o carregamento da página, mas o global serve de
                // respaldo caso a resposta venha sem o campo.
                const number = channel === 'whatsapp' ? (data.redirectNumber || window.wppNumber) : null;

                // Sem cota/resultado pra simulação: não tem PDF pra enviar, então
                // não confirma o envio nem abre o WhatsApp — leva pra etapa 3,
                // que mostra a mensagem de que não há resultados.
                if (data.status === true && data.no_result && data.redirect) {
                    if (channel === 'whatsapp') failWhatsapp();
                    window.location = data.redirect;
                    return;
                }

                if (data.status === true && (channel !== 'whatsapp' || number)) {
                    if (channel === 'email') {
                        // Sem redirecionamento automático: o usuário precisa de
                        // tempo pra ler a confirmação. O botão "Voltar" do pop-up
                        // leva de volta pra etapa 1 do fluxo B.
                        self.showStep('confirmation-email');
                        if (Loader) Loader.classList.remove('open-modal');
                        return;
                    }

                    self.showStep('confirmation');

                    if (channel === 'whatsapp') {
                        const message = data.wppRedirectMessage || '';
                        const waUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

                        if (waWindow && !waWindow.closed) {
                            waWindow.location.href = waUrl;
                        } else {
                            window.open(waUrl, '_blank');
                        }
                    }

                    if (Loader) Loader.classList.remove('open-modal');

                    if (data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2500);
                    }

                    return;
                }

                if (Loader) Loader.classList.remove('open-modal');
                if (channel === 'whatsapp') failWhatsapp();

                input.classList.add('is-invalid');
                if (error) {
                    error.textContent = data.txt || 'Não foi possível enviar seus dados. Tente novamente.';
                    error.style.display = 'block';
                }
            }

            errorFunction() {
                if (submitButton) submitButton.disabled = false;
                if (Loader) Loader.classList.remove('open-modal');
                if (channel === 'whatsapp') failWhatsapp();

                input.classList.add('is-invalid');
                if (error) {
                    error.textContent = 'Ocorreu um erro. Tente novamente mais tarde.';
                    error.style.display = 'block';
                }
            }
        }

        const ajax = new FinalStep(form, 'POST', form.action, 'json', formData);
        if (channel === 'whatsapp') {
            // Este endpoint (simulatorFormThird) não valida reCAPTCHA no backend.
            ajax.sendNoRecaptcha();
        } else {
            ajax.send();
        }
    }
}
